import React from "react";
import {translate} from "Core/i18n";
import {
	app_id, locale_cookie_group,
	sidebar_menu_groups_statuses_storage_field_name, sidebar_menu_shrank_cookie_group, skin_mode_cookie_group
} from 'Config/app';

/**
 * Cookie policy for sr-Latn-RS locale
 * @note This will automatically be used in CookiePolicy component (index.js) if sr-Latn-RS is the current locale. 
 * There is no need to use this component directly.
 * 
 * @param {any} props - Any prop that will be added to the DIV element.
 * @return {JSX.Element}
 * @constructor
 */
function CookiePolicySrLatnRS(props) {
	return (
		<div {...props}>
			<h2>O kolačićima</h2>
			<p>Kolačić na web sajtu je mala tekstualna datoteka koju web sajt čuva na Vašem računaru ili mobilnom uređaju kada ga posetite. Zamislite ga kao memoriju web sajta. Ove datoteke su vrlo česte i neophodne za efikasno funkcionisanje interneta. Kolačići omogućavaju web sajtu da "zapamti" Vaše akcije i podešavanja (kao što su informacije o prijavi, izbor jezika ili preference) tokom određenog vremenskog perioda, tako da ne morate ponovo da ih unosite kada se vratite na sajt ili prelazite sa jedne stranice na drugu.</p>
			<p>Kolačići imaju nekoliko važnih funkcija. Neki su <strong>{translate('name', 'CookieSettings.tab.@cookieGroup:necessary').toLowerCase()}</strong> za osnovno funkcionisanje web sajta - na primer, da Vam omoguće prijavu. Drugi, često nazvani <strong>{translate('name', `CookieSettings.tab.@cookieGroup:functional`).toLowerCase()}</strong> ili <strong>{translate('name', `CookieSettings.tab.@cookieGroup:analytics`).toLowerCase()}</strong> kolačići, pomažu nam da razumemo kako posetioci koriste naš sajt, što nam omogućava da poboljšamo izgled, sadržaj i korisničko iskustvo. Konačno, <strong>{translate('name', `CookieSettings.tab.@cookieGroup:marketing`)}</strong> kolačići se mogu koristiti za prikazivanje reklama koje su relevantnije za Vas i Vaša interesovanja, ili za ograničavanje broja prikazivanja određene reklame.</p>
			<p>Vi imate kontrolu nad tim koje kolačiće prihvatate. Većina web pretraživača je podešena da podrazumevano prihvata kolačiće, ali možete koristiti ovaj dijalog da izaberete kolačiće koje želite da dozvolite. Međutim, imajte na umu da ako odlučite da odbijete kolačiće, neki delovi našeg web sajta možda neće pravilno funkcionisati ili Vam mogu postati nedostupni. Za detaljnije informacije o upravljanju i brisanju kolačića, možete konsultovati odeljak "Pomoć" Vašeg pretraživača.</p>
			<p>Listu svih kolačića koje koristimo možete pronaći u tabeli "Specifikacija kolačića" ispod.</p>

			<h2>Specifikacija kolačića</h2>
			<div className="data-table-component standard">
				<table>
					<thead>
						<tr>
							<th className="column"><div className="content">KATEGORIJA</div></th>
							<th className="column" width="1"><div className="content">NAZIV</div></th>
							<th className="column"><div className="content">OPIS</div></th>
						</tr>
					</thead>

					<tbody>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_pauseRequests</div></td>
							<td><div className="content">Kolačić koji se koristi za pauziranje sistemskih procesa</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_authToken</div></td>
							<td><div className="content">Kolačić koji se koristi za autorizaciju ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_authTokenData</div></td>
							<td><div className="content">Kolačić koji sadrži autorizacioni ključ trenutno ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_refreshToken</div></td>
							<td><div className="content">Kolačić koji se koristi za autorizaciju ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_refreshingToken</div></td>
							<td><div className="content">Kolačić koji se koristi za autorizaciju ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_acl</div></td>
							<td><div className="content">Kolačić koji sadrži listu privilegija trenutno ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_currentUserName</div></td>
							<td><div className="content">Kolačić koji sadrži korisničko ime trenutno ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_currentUser</div></td>
							<td><div className="content">Kolačić koji sadrži sistemske podatke trenutno ulogovanog korisnika (korisničko ime, tip, itd.)</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_userActivity</div></td>
							<td><div className="content">Kolačić koji sadrži sistemske podatke o aktivnosti trenutno ulogovanog korisnika</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">projectId</div></td>
							<td><div className="content">Kolačić koji sadrži identifikator trenutno izabranog projekta</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', 'CookieSettings.tab.@cookieGroup:necessary')}</div></td>
							<td><div className="content">{app_id}_cookie_consent_settings</div></td>
							<td><div className="content">Kolačić koji sadrži informaciju o tome koje kolačiće je korisnik prihvatio</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${locale_cookie_group}`)}</div></td>
							<td><div className="content">{app_id}_locale</div></td>
							<td><div className="content">Kolačić koji sadrži sistemski kod regiona na osnovu kojeg se određuje jezik koji će biti korišćen</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${sidebar_menu_shrank_cookie_group}`)}</div></td>
							<td><div className="content">sidebar_menu_shrank</div></td>
							<td><div className="content">Kolačić koji određuje veličinu glavnog navigacionog menija</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:necessary`)}</div></td>
							<td><div className="content">{sidebar_menu_groups_statuses_storage_field_name}</div></td>
							<td><div className="content">Kolačić koji određuje koji elementi glavnog navigacionog menija će biti otvoreni</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${skin_mode_cookie_group}`)}</div></td>
							<td><div className="content">skin_mode</div></td>
							<td><div className="content">Kolačić koji određuje temu (boje) aplikacije</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:${skin_mode_cookie_group}`)}</div></td>
							<td><div className="content">use_system_skin_mode</div></td>
							<td><div className="content">Kolačić koji određuje temu (boje) aplikacije</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:functional`)}</div></td>
							<td><div className="content">emoji-mart.frequently</div></td>
							<td><div className="content">Kolačić koji čuva listu najčešće korišćenih emotikona kako bi oni bili dostupni prilikom ubacivanja emotikona u neki sadržaj</div></td>
						</tr>
						<tr>
							<td><div className="content">{translate('name', `CookieSettings.tab.@cookieGroup:functional`)}</div></td>
							<td><div className="content">emoji-mart.last</div></td>
							<td><div className="content">Kolačić koji čuva informaciju o poslednje korišćenom emotikonu</div></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default CookiePolicySrLatnRS;